import { NUMBER_UI_TEST_1_240528 } from "@faire/web-api/indigofair/settings/NUMBER_UI_TEST_1_240528";

import {
  assignSetting,
  getSettingValueWithoutAssignment,
} from "@faire/retailer/settings/__internal__/getSetting";

export const getSettingAutoSignUpModalTiming = (): number =>
  getSettingValueWithoutAssignment(NUMBER_UI_TEST_1_240528, 0);

export const assignSettingAutoSignUpModalTiming = () =>
  assignSetting(NUMBER_UI_TEST_1_240528);
